// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if ({ "index":1,"vendors-node_modules_dayjs_dayjs_min_js-node_modules_dayjs_plugin_utc_js-node_modules_moment_-5a9057":1 }[chunkId]) return "static/css/" + chunkId + ".css";
  // return url for filenames based on template
  return "static/css/async/" + chunkId + ".css"
}